import React, { useState, useContext, useEffect } from 'react';
import { AppSettings } from './../../config/app-settings.js';
import { Icon } from '@iconify/react';
import { Tooltip } from 'bootstrap';

function ThemePanel() {
	const { appThemePanelToggled, setAppThemePanelToggled } = useContext(AppSettings);
	const [theme, setTheme] = useState();
	const [rtlEnabled, setRtlEnabled] = useState(localStorage?.rtlEnabled === 'true');
	
	const toggleAppThemePanel = (event) => {
		event.preventDefault();
		
		var state = (appThemePanelToggled === 'true' || appThemePanelToggled === true) ? false : true;
		
		setAppThemePanelToggled(state);
		if (localStorage) {
			localStorage.setItem('appThemePanelToggled', state);
		}
	}
	
	const toggleAppTheme = (event, t) => {
		event.preventDefault();
		
		setAppTheme(t);
	}
	
	const setAppTheme = (t) => {
		for (var x = 0; x < document.body.classList.length; x++) {
			if ((document.body.classList[x]).indexOf('theme-') > -1 && document.body.classList[x] !== t) {
				document.body.classList.remove(document.body.classList[x]);
			}
		}
		if (t) {
			document.body.classList.add(t);
		}
		if (localStorage) {
			localStorage.setItem('appTheme', t);
		}
		
		setTheme(t);
		document.dispatchEvent(new Event('theme-reload'));
	}

	const handleRtlToggle = (e) => {
		const isEnabled = e.target.checked;
		setRtlEnabled(isEnabled);
		if (isEnabled) {
			document.documentElement.setAttribute('dir', 'rtl');
		} else {
			document.documentElement.removeAttribute('dir');
		}
		localStorage.setItem('rtlEnabled', isEnabled.toString());
	};
	
	const themeList = [
	 { name: 'Pink', bgClass: 'bg-pink', themeClass: 'theme-pink' },
	 { name: 'Red', bgClass: 'bg-red', themeClass: 'theme-red' },
	 { name: 'Orange', bgClass: 'bg-warning', themeClass: 'theme-warning' },
	 { name: 'Yellow', bgClass: 'bg-yellow', themeClass: 'theme-yellow' },
	 { name: 'Lime', bgClass: 'bg-lime', themeClass: 'theme-lime' },
	 { name: 'Green', bgClass: 'bg-green', themeClass: 'theme-green' },
	 { name: 'Default', bgClass: 'bg-teal', themeClass: 'theme-teal' },
	 { name: 'Cyan', bgClass: 'bg-info', themeClass: 'theme-info' },
	 { name: 'Blue', bgClass: 'bg-primary', themeClass: 'theme-primary' },
	 { name: 'Purple', bgClass: 'bg-purple', themeClass: 'theme-purple' },
	 { name: 'Indigo', bgClass: 'bg-indigo', themeClass: 'theme-indigo' },
	 { name: 'Gray', bgClass: 'bg-gray-200', themeClass: 'theme-gray-200' }
	];
	
	useEffect(() => {
		var elm = document.querySelectorAll('[data-bs-toggle="tooltip"]');
		
		for (var i = 0; i < elm.length; i++) {
			new Tooltip(elm[i]);
		}
		if (localStorage && localStorage.getItem('appThemePanelToggled') === 'true') {
			setAppThemePanelToggled(true);
		}
		if (localStorage && localStorage.getItem('appTheme')) {
			setTheme(localStorage.getItem('appTheme'));
		}
		if (rtlEnabled) {
			document.documentElement.setAttribute('dir', 'rtl');
		}
		
		// eslint-disable-next-line
  }, []);
	
	return (
		<div className={'app-theme-panel' + ((appThemePanelToggled && (appThemePanelToggled === 'true' || appThemePanelToggled === true)) ? ' active' : '')}>
			<div className="app-theme-panel-container">
				<a href="#/" onClick={toggleAppThemePanel} className="app-theme-toggle-btn"><Icon icon="ph:gear-duotone" /></a>
				<div className="app-theme-panel-content">
					<div className="fs-10px fw-semibold text-white">
						THEME COLOR
					</div>
					<div className="fs-9px lh-sm mb-2 text-white text-opacity-75">
						Choose your favorite theme color
					</div>
					<div className="app-theme-list">
						{themeList.length > 0 && themeList.map((t, index) => (
							<div className={'app-theme-list-item ' + ((theme === t.themeClass) ? 'active' : '')} key={index}>
								<a href="#/" onClick={(event) => toggleAppTheme(event, t.themeClass)} className={'app-theme-list-link '+ t.bgClass} data-bs-toggle="tooltip" data-bs-trigger="hover" data-bs-container="body">&nbsp;</a>
							</div>
						))}
					</div>
					<hr />
					<div className="d-flex">
						<div className="flex-1 pe-2">
							<div className="d-flex fs-10px fw-semibold text-white align-items-center">RTL MODE <span className="badge bg-theme text-theme-color ms-2 position-relative d-flex align-items-center">NEW</span></div>
							<div className="fs-9px lh-sm mb-2 text-white text-opacity-75">
								Flip the layout direction to support right-to-left languages.
							</div>
						</div>
						<div className="form-check form-switch m-0 me-n2">
							<input type="checkbox" className="form-check-input" name="app-theme-rtl" id="appThemeRtl" checked={rtlEnabled} onChange={handleRtlToggle} />
							<label className="form-check-label" htmlFor="appThemeRtl"></label>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default ThemePanel;
